function t(r,e,n){return e()}export{t as useSyncExternalStore};
